import { OKELink, UI_BODY_BOLD_SM, UI_CAPTION } from "oolib";
import React from "react";
import styled from "styled-components";

const StylesTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.8rem;
  gap: 0.6rem;
  max-width: 30rem;
`
const StyledImportInfoTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1.2rem;
  gap: 1.2rem;
  max-width: 27.4rem;
`
const StyledTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`

// Keyed by field-type option KEY (see okf-be directImportFieldTypeOptions.js
// — the same keys the dropdown options carry), not by comp: Short Text and
// Long Text share comp LexicalTextEditor.
export const fieldTypeTooltips = {
  title: "Use this field type to uniquely identify each document in your dataset.",
  shortText: "Use this field type for short text like names, labels, IDs, or brief notes. Kept as simple text and not included in AI analysis by default.",
  longText: "Use this field type for longer qualitative content like transcripts, summaries, or open responses. Included in AI analysis for highlights and insights.",
  date: "Use this field to add date values. Dates can be analyzed over time and used in time-series visualizations.",
  number: "Use this field type for numeric values. Numbers are analyzed within relevant ranges for calculations and comparisons.",
  url: "Use this field type to store external or reference links related to your data.",
  singleSelect: "Use this field type when one option applies for each entry.",
  multiSelect: "Use this field when more than one option applies for each entry using a chosen separator.",
  tagsSingle: "Use this field type to assign one tag to each entry. Tags help organize, filter, and connect data across datasets and form the basis of data connectors.",
  tagsMulti: "Use this field type to assign multiple tags to each entry using a chosen separator. Tags help organize, filter, and connect data across datasets and form the basis of data connectors.",
  simpleTable: "Use this field type for tabular data stored as CSV within a cell. The first row of the CSV becomes column headers.",
  dateTime: "Use this field type for date and time values combined.",
  jsonInput: "Use this field type to store structured JSON data.",
};

// export const fieldTypeTooltipConfig = {
//   layout: "TooltipHeading",
//   props: {
//     blocks: [
//       { heading: "Document Title", text: fieldTypeTooltips.title },
//       { heading: "Text", text: fieldTypeTooltips.TextInput },
//       { heading: "Rich Text", text: fieldTypeTooltips.LexicalTextEditor },
//       { heading: "URL", text: fieldTypeTooltips.URLInput },
//       { heading: "Number", text: fieldTypeTooltips.NumberInput },
//       { heading: "Date", text: fieldTypeTooltips.DatePicker },
//       { heading: "Single Select", text: fieldTypeTooltips.DropdownSingle },
//       { heading: "Multi Select", text: fieldTypeTooltips.DropdownMulti },
//       { heading: "Single Tags", text: fieldTypeTooltips.TagsInputSingle },
//       { heading: "Multi Tags", text: fieldTypeTooltips.TagsInputMulti },
//     ],
//   },
// };

export const fieldTypeTooltipConfig = {
  layout: 'custom',
  render: (
    <StylesTooltipContent>
      <UI_CAPTION>{fieldTypeTooltips.title}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.shortText}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.longText}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.url}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.number}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.date}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.dateTime}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.singleSelect}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.multiSelect}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.tagsSingle}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.tagsMulti}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.simpleTable}</UI_CAPTION>
      <UI_CAPTION>{fieldTypeTooltips.jsonInput}</UI_CAPTION>
    </StylesTooltipContent>
  )
};

// export const importInfoTooltipContent = {
//   layout: "TooltipHeading",
//   props: {
//     blocks: [
//       {
//         text: "This is where you set up how your dataset is structured on Dots. Here, you'll assign field types and name each field.",
//       },
//       {
//         heading: "Fields",
//         text: "Fields are the individual pieces of information in your dataset. On this platform, documents and fields are defined by rows and columns — if a document is a row, each column becomes a field, and vice versa.",
//       },
//       {
//         heading: "Field Types",
//         text: "Every field must be assigned a field type. Hover over a field type to view its description and intended use. Different field types are analyzed in different ways, so choose carefully.",
//       },
//       {
//         heading: "Preview",
//         text: "Use the preview panel below to see how one document from your dataset will look after import.",
//       },
//       {
//         link: {
//           text: "Learn more about field types",
//           href: "https://dots.gitbook.io/dots-docs/data-import/data-import",
//           newTab: true,
//         },
//       },
//     ],
//   },
// };

export const importInfoTooltipContent = {
  layout: 'custom',
  render: (
    <StyledImportInfoTooltipContent>
      <UI_CAPTION>
        This is where you set up how your dataset is structured on Dots. Here, you'll assign field types and name each field.
      </UI_CAPTION>
      <StyledTooltipContent>
        <UI_BODY_BOLD_SM>Fields</UI_BODY_BOLD_SM>
        <UI_CAPTION>
          Fields are the individual pieces of information in your dataset. On this platform, documents and fields are defined by rows and columns — if a document is a row, each column becomes a field, and vice versa.
        </UI_CAPTION>
      </StyledTooltipContent>

      <StyledTooltipContent>
        <UI_BODY_BOLD_SM>Field Types</UI_BODY_BOLD_SM>
        <UI_CAPTION>
          Every field must be assigned a field type. Hover over a field type to view its description and intended use. Different field types are analyzed in different ways, so choose carefully.
        </UI_CAPTION>
        <UI_CAPTION>
          <OKELink
            link="https://dots.gitbook.io/dots-docs/data-import/data-import"
            text="Learn more about field types"
            color={"white"}
          />
        </UI_CAPTION>
      </StyledTooltipContent>
      {/* <StyledTooltipContent>
        <UI_BODY_BOLD_SM>Preview</UI_BODY_BOLD_SM>
        <UI_CAPTION>
          Use the preview panel below to see how one document from your dataset will look after import.
        </UI_CAPTION>
      </StyledTooltipContent> */}
    </StyledImportInfoTooltipContent>
  )
}